import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import toastr from 'toastr';

import { ExportFormModal } from './ExportFormModal';
import { exportVoucher } from './action';

function ExportContainer(props) {
    const {
        selectedVoucher,
        show,
        onModalClose
    } = props;

    const [startDate, setStartDate] = useState(moment());
    const endDate = useMemo(() =>
        moment(startDate).add(selectedVoucher.duration, 'days'), [selectedVoucher.duration, startDate]);

    async function handleSubmit(values, actions) {
        const voucher = {
            quantity: values.quantity,
            format: values.format,
            validFrom: moment(values.startDate),
            validTo: endDate,
            purpose: values.purpose,
            zipPassword: values.zipPassword
        };

        const response = await props.exportVoucher(selectedVoucher.id, voucher);
        if (!response.isSuccess) {
            toastr.error(response.payload.error, 'Error');
        } else {
            handleClose();
        }

        actions.setSubmitting(false);        
    }

    function handleClose() {
        setStartDate(moment());
        onModalClose();
    }

    function handleDateChange(event, picker, setFieldValue) {
        setFieldValue('startDate', picker.startDate);
        setStartDate(picker.startDate);
    }

    return (
        <ExportFormModal
            show={show}
            endDate={endDate}
            onFormSubmit={handleSubmit}
            onModalClose={handleClose}
            onDateChange={handleDateChange}
        />
    );
}

export default connect(null, { exportVoucher })(ExportContainer);